/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CoverageRepresentation
 */
export interface CoverageRepresentation {
    /**
     * 
     * @type {string}
     * @memberof CoverageRepresentation
     */
    metricKey: string;
    /**
     * 
     * @type {number}
     * @memberof CoverageRepresentation
     */
    coverageFrom: number;
    /**
     * 
     * @type {number}
     * @memberof CoverageRepresentation
     */
    coverageTo: number;
}

/**
 * Check if a given object implements the CoverageRepresentation interface.
 */
export function instanceOfCoverageRepresentation(value: object): value is CoverageRepresentation {
    if (!('metricKey' in value) || value['metricKey'] === undefined) return false;
    if (!('coverageFrom' in value) || value['coverageFrom'] === undefined) return false;
    if (!('coverageTo' in value) || value['coverageTo'] === undefined) return false;
    return true;
}

export function CoverageRepresentationFromJSON(json: any): CoverageRepresentation {
    return CoverageRepresentationFromJSONTyped(json, false);
}

export function CoverageRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): CoverageRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'metricKey': json['metricKey'],
        'coverageFrom': json['coverageFrom'],
        'coverageTo': json['coverageTo'],
    };
}

export function CoverageRepresentationToJSON(json: any): CoverageRepresentation {
    return CoverageRepresentationToJSONTyped(json, false);
}

export function CoverageRepresentationToJSONTyped(value?: CoverageRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'metricKey': value['metricKey'],
        'coverageFrom': value['coverageFrom'],
        'coverageTo': value['coverageTo'],
    };
}

